import cx from 'classnames';
import {format, parseISO} from 'date-fns';

import {Icon, Text} from '#component/base';

import {KitRegisteredProps} from './KitRegisteredPill.types';

import * as css from './KitRegisteredPill.css';

/**
 * KitRegistedPill renders a compact "pill" UI that displays the
 * date of the current kit's registration.
 */
export const KitRegisteredPill = ({
  className,
  children,
  registeredDate,
  variant = 'primary',
  ...otherProps
}: KitRegisteredProps) => (
  <Text className={cx(css.root({variant}), className)} variant="caption" {...otherProps}>
    {registeredDate && (
      <Icon
        aria-label="This data is for the kit registered on:"
        color={variant === 'primary' ? 'eggplantDark' : 'currentColor'}
        name="CalendarBlank"
        size="xSmall"
      />
    )}
    {registeredDate && format(parseISO(registeredDate), 'MMM d, yyyy')}
    {children}
  </Text>
);
